import {
    Box,
    Grid,
    Stack,
    Typography,
    useTheme
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import DrawIcon from '@mui/icons-material/Draw';
import PhishingIcon from '@mui/icons-material/Phishing';
import Filter9Icon from '@mui/icons-material/Filter9';
import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import Title1Component from '../../../components/title/title1Component';

const uspList = [
    {
        color: "#156688",
        icon: <DrawIcon sx={{color: 'white'}}/>,
        title: "usp.usp1.title",
        description: "usp.usp1.description"
    },
    {
        color: "#21aef3",
        icon: <PhishingIcon sx={{color: 'white'}}/>,
        title: "usp.usp2.title",
        description: "usp.usp2.description"
    },
    {
        color: "#24cd95",
        icon: <Filter9Icon sx={{color: 'white'}}/>,
        title: "usp.usp3.title",
        description: "usp.usp3.description"
    },
    {
        color: "#cd249d",
        icon: <GraphicEqIcon sx={{color: 'white'}}/>,
        title: "usp.usp4.title",
        description: "usp.usp4.description"
    }
]

const UspView = () => {
    const theme = useTheme();
    const {t} = useTranslation();

    return (
        <>
            <Stack
                direction='column'
                justifyContent='center'
                alignItems='center'
                className='bodySpacing bodyPadding'
                sx={{
                    backgroundColor: theme.palette.primary.main
                }}
            >
                <Title1Component title={t('usp.title')} description={t('usp.description')}/>

                <Grid
                    direction='row'
                    justifyContent='center'
                    alignItems='center'
                    container
                    spacing={{xs: 1, md: 5}}
                >
                    {
                        uspList.map((item, index) => {
                            return <Grid 
                                key={index}
                                size={{xs: 12, md: 3}}
                                sx={{
                                    width: '100%'
                                }}
                                data-aos="zoom-in-down"
                                data-aos-delay={index * 150}
                                data-aos-duration="1000"
                            >
                                <UspDetails data={item}/>
                            </Grid>
                        })
                    }
                </Grid>
            </Stack>
        </>
    );
}

export default UspView;

const UspDetails = ({data}) => {
    const {t} = useTranslation();

    return (
        <>
            <Box
                sx={{
                    borderRadius: 4,
                    backgroundColor: data.color,
                    p: {xs: 2, md: 5},
                    minHeight: {xs: 100, md: 250, lg: 200}
                }}
            >
                <Stack
                    direction='column'
                    justifyContent='center'
                    alignItems='start'
                    spacing={{xs: 1, md: 2}}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center'
                        }}
                    >
                        {data.icon}
                    </Box>

                    <Typography
                        sx={{
                            fontWeight: 700,
                            fontSize: {xs: 16, md: 20, lg: 32},
                            color: 'white',
                            lineHeight: 1
                        }}
                    >
                        {t(data.title)}
                    </Typography>

                    <Typography
                        sx={{
                            fontWeight: 400,
                            fontSize: {xs: 12, md: 14, lg: 16},
                            textAlign: 'left',
                            color: 'white'
                        }}
                    >
                        {t(data.description)}
                    </Typography>
                </Stack>
            </Box>
        </>
    );
}